// extracted by mini-css-extract-plugin
export var cardImage = "imageDialogs-module--card-image--32d31";